'use strict';

module.exports = imageReference;

var normalize = require('mdurl/encode');

var revert = require('../revert');

function imageReference(h, node) {
  var def = h.definition(node.identifier);
  var props;

  if (!def) {
    return revert(h, node);
  }

  props = {
    src: normalize(def.url || ''),
    alt: node.alt
  };

  if (def.title !== null && def.title !== undefined) {
    props.title = def.title;
  }

  return h(node, 'img', props);
}